// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"789":"css/app.6845","5110":"css/admin-app.6845"}[chunkId] + ".css";
};